import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import StarIcon from "@material-ui/icons/Star";
import { markupDeliveries, showRating, showYears } from "./helper";
const useStyles = makeStyles(({
  palette
}) => ({
  ratingContainer: {
    fontSize: "1.1em",
    display: "flex",
    textAlign: "center",
    whiteSpace: "nowrap"
  },
  statisticItem: {
    "& + &": {
      borderLeft: "solid 1px",
      borderColor: palette.border.default,
      marginLeft: "1.4em",
      paddingLeft: "1.4em"
    }
  },
  iconStar: {
    position: "absolute",
    transform: "translate(2px, -4px)",
    fontSize: "1.2rem",
    color: palette.primary.main
  },
  message: {
    fontSize: "0.875rem",
    color: palette.text.headline
  }
}));

const DriverStatistic = ({
  deliveries,
  rating,
  years,
  className
}) => {
  const styles = useStyles();
  const preparedDeliveries = deliveries && markupDeliveries(deliveries);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ratingContainer
  }, preparedDeliveries && /*#__PURE__*/React.createElement("div", {
    className: styles.statisticItem
  }, /*#__PURE__*/React.createElement("div", null, preparedDeliveries), /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, "Deliveries")), showRating(rating) && /*#__PURE__*/React.createElement("div", {
    className: styles.statisticItem
  }, /*#__PURE__*/React.createElement("div", null, Number(rating).toFixed(1), /*#__PURE__*/React.createElement(StarIcon, {
    className: styles.iconStar
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, "Rating")), showYears(years) && /*#__PURE__*/React.createElement("div", {
    className: styles.statisticItem
  }, /*#__PURE__*/React.createElement("div", null, years), /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, "Years"))));
};

export default DriverStatistic;